export default "__VITE_ASSET__B0_H$lD$__"